export interface PauseListingsProps {
  pauseState: boolean
  userAction?: boolean
  userId: string
  id: string
}

export interface PauseListingsModalProps {
  loading: boolean
  error: boolean
  handlePauseClick: (
    isPause: boolean,
    reason: PauseReasonsEnum,
    additionalInfo?: string
  ) => Promise<void>
}

export enum PauseReasonsEnum {
  PENDING_REVIEW = 'pending_review',
  FRAUD = 'fraud',
  SELLER_LATE_SHIPPING = 'seller_late_shipping',
  SELLER_NOT_SHIPPING = 'seller_not_shipping',
  SELLER_LOGISTICAL_REASONS = 'seller_logistical_reasons'
}
